import {
    CALENDAR_HATCH_ROUTE,
    HATCH_PIN_ROUTE,
    HATCH_SAVE_VIEW_ROUTE
} from './constants';
import http from '../../../utils/httpService';
import { getCookie } from '../../../utils/cookieService';

/**
 *
 * @param data
 */
const requestCreateHatch = data => {
    const body = {
        ...data
    };
    return http.request( CALENDAR_HATCH_ROUTE, 'POST', body );
};
/**
 *
 * @param id
 * @param data
 */
const requestUpdateHatch = ( id, data ) => {
    const route = CALENDAR_HATCH_ROUTE + `/${ id }`;
    const body = {
        ...data
    };
    return http.request( route, 'PUT', body );
};
/**
 *
 * @param id
 */
const requestDeleteHatch = id => {
    const route = CALENDAR_HATCH_ROUTE + `/${ id }`;
    return http.request( route, 'DELETE' );
};
/**
 *
 * @param hatchID
 */
const requestPinHatch = ( hatchID ) => {
    const route = HATCH_PIN_ROUTE + `/${ hatchID }`;

    return http.request( route, 'POST' );
};
/**
 *
 * @param hatchID
 */
const requestSaveViewHatch = hatchID => {
    const uuid = getCookie( 'uuid' );
    const body = {
        hatch_id: hatchID,
        item_type: 'hatch',
        uuid_front: uuid
    };
    return http.request( HATCH_SAVE_VIEW_ROUTE, 'POST', body );
};

export {
    requestCreateHatch,
    requestUpdateHatch,
    requestDeleteHatch,
    requestPinHatch,
    requestSaveViewHatch
};